import { createSlice } from "@reduxjs/toolkit";

export const reportsSlice = createSlice({
  name: "reportsSlice",
  initialState: {
    deviceAsciiId: [],
  },
  reducers: {
    addId: (state, action) => {
        if(action.payload!=0){
            state.deviceAsciiId.push(action.payload);
        }
    },
  },
});
export const { addId } = reportsSlice.actions;
export default reportsSlice.reducer;
